import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { UserService } from 'src/app/shared/user.service';
import { TranslateService } from '@ngx-translate/core';
import { tVerModel, currentVerInfoID } from 'src/app/models/non-master-model/tVerModel';
import { tVerService } from 'src/app/services/Non-Master/tVer.service';
import { isNullOrUndefined } from 'util';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NavigationComponent } from '../navigation/navigation.component';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginMessage = '';

  formModel = {
    UserName: '',
    Password: ''
  };

  isSubmit = false;

  tVerModel: tVerModel = new tVerModel;

  constructor( private service: UserService,
    private router: Router,
    private translate: TranslateService,
    private tVerService: tVerService,
    public datepipe: DatePipe,
    private http:HttpClient) { }

  ngOnInit() {


    if (localStorage.getItem('token') != null) {
      // this.router.navigateByUrl('/home');
      // this.router.navigate(['/home']);
      this.router.navigate(['/main']);

    }

    // Get Version
    this.tVerService.getInfoByID(currentVerInfoID.id).subscribe(data => {
      this.tVerModel = data;
    });
  }


  onSubmit() {
    console.log("submit");
    this.isSubmit = !this.isSubmit;
    this.loginMessage = '';

    this.service.login(this.formModel).subscribe(
      (res: any) => {
        localStorage.setItem('token', res.token);
        this.router.navigate(['/main/home']);
      }, err => {
        this.isSubmit = !this.isSubmit;
        if (err.status === 400) {
          this.translate.get('Message_InvaildLogin').subscribe((message: string) => {
            this.loginMessage = message;
          });
          // this.toastr.error('Incorrect username or password.','Authentication failed');
        } else {

          this.translate.get('StatusCode_500').subscribe((message: string) => {
            this.loginMessage = message;
          });

          console.log(err);
        }
      }
    );
  }

  displayDateTime(currDate: Date) {

    if (!isNullOrUndefined(currDate)) {
      return this.datepipe.transform(currDate, 'yyyy/MM/dd HH:mm:ss');
      // return this.datepipe.transform(currDate, 'yyyy/MM/dd');
    }
    else
    {
      return '';
    }

  }



}
